// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme__Color$PrezzeeRibbon from "./Theme__Color.bs.js";

function InputStyles(V, F, C, S, U) {
  var variantCss = function (v) {
    switch (v) {
      case /* Regular */0 :
          return V.regular;
      case /* Small */1 :
          return V.small;
      case /* Icon */2 :
          return V.icon;
      
    }
  };
  var fillCss = function (f) {
    switch (f) {
      case /* Contained */0 :
          return F.contained;
      case /* Outlined */1 :
          return F.outlined;
      case /* None */2 :
          return F.none;
      
    }
  };
  var colourCss = function (c, f, t) {
    var fillFn;
    switch (f) {
      case /* Contained */0 :
          fillFn = C.containedColours;
          break;
      case /* Outlined */1 :
          fillFn = C.outlinedColours;
          break;
      case /* None */2 :
          fillFn = C.noneColours;
          break;
      
    }
    if (typeof c !== "number") {
      return Curry._3(fillFn, c._0, c._1, c._2);
    }
    switch (c) {
      case /* Red */0 :
          return Curry._3(fillFn, Theme__Color$PrezzeeRibbon.Personal.primaryRed, Theme__Color$PrezzeeRibbon.Personal.white, Theme__Color$PrezzeeRibbon.Personal.primaryRedHover);
      case /* Charcoal */1 :
          return Curry._3(fillFn, Theme__Color$PrezzeeRibbon.Personal.charcoal, Theme__Color$PrezzeeRibbon.Personal.white, Theme__Color$PrezzeeRibbon.Personal.charcoalHover);
      case /* White */2 :
          return Curry._3(fillFn, Theme__Color$PrezzeeRibbon.Personal.white, Theme__Color$PrezzeeRibbon.Personal.darkGrey, Theme__Color$PrezzeeRibbon.Personal.whiteHover);
      case /* BusinessPurple */3 :
          return Curry._3(fillFn, Theme__Color$PrezzeeRibbon.Business.prezzeePurple, Theme__Color$PrezzeeRibbon.Business.white, Theme__Color$PrezzeeRibbon.Business.darkPurple);
      case /* BusinessCharcoal */4 :
          return Curry._3(fillFn, Theme__Color$PrezzeeRibbon.Business.charcoal, Theme__Color$PrezzeeRibbon.Business.white, Theme__Color$PrezzeeRibbon.Business.charcoal);
      case /* Primary */5 :
          return Curry._3(fillFn, t.primary.default, t.primary.defaultText, t.primary.hover);
      case /* Secondary */6 :
          return Curry._3(fillFn, t.secondary.default, t.secondary.defaultText, t.secondary.hover);
      case /* Tertiary */7 :
          return Curry._3(fillFn, t.tertiary.default, t.tertiary.defaultText, t.tertiary.hover);
      
    }
  };
  var shadowCss = function (s) {
    if (s) {
      return S.normal;
    } else {
      return S.none;
    }
  };
  var inputCss = function (c, f, v, s, t) {
    return [
            Curry._1(U.universal, t.borderRadius),
            colourCss(c, f, t),
            fillCss(f),
            variantCss(v),
            s ? S.normal : S.none
          ];
  };
  return {
          variantCss: variantCss,
          fillCss: fillCss,
          colourCss: colourCss,
          shadowCss: shadowCss,
          inputCss: inputCss
        };
}

export {
  InputStyles ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
